import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type ApplicationListEndpointContextDataFragment = (
  { __typename: 'ApplicationListEndpoint' }
  & Pick<SchemaTypes.ApplicationListEndpoint, 'id' | 'applicationModuleIds' | 'applicationStage' | 'title' | 'pathname'>
);

export const ApplicationListEndpointContextDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ApplicationListEndpointContextData on ApplicationListEndpoint {
  id
  applicationModuleIds
  applicationStage
  title
  pathname
}
    `;